import { Box, Button, Chip, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { FieldValue } from '../../../../../../types/QueryBuilder';

interface DualListOptionRowProps {
    option: FieldValue;
    membership: 'include' | 'exclude' | null;
    includeLabel: string;
    excludeLabel: string;
    onAdd: (list: 'include' | 'exclude') => void;
    onRemove: (list: 'include' | 'exclude') => void;
}

function DualListOptionRow({ option, membership, includeLabel, excludeLabel, onAdd, onRemove }: DualListOptionRowProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                px: 1,
                py: 0.5,
                minHeight: 40,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-of-type': { borderBottom: 'none' },
            }}
        >
            <Typography
                variant="body2"
                sx={{ color: '#495057', flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                title={option.label}
            >
                {option.label}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 0.5, flexShrink: 0, minWidth: { xs: 0, sm: 280 } }}>
                {membership === 'include' ? (
                    <Chip size="small" color="success" label={includeLabel} onDelete={() => onRemove('include')} />
                ) : membership === 'exclude' ? (
                    <Chip size="small" color="error" label={excludeLabel} onDelete={() => onRemove('exclude')} />
                ) : (
                    <>
                        <Button size="small" startIcon={<AddIcon fontSize="small" />} onClick={() => onAdd('include')} sx={{ textTransform: 'none', color: '#2e7d32', whiteSpace: 'nowrap' }}>
                            {includeLabel}
                        </Button>
                        <Button size="small" startIcon={<AddIcon fontSize="small" />} onClick={() => onAdd('exclude')} sx={{ textTransform: 'none', color: '#c62828', whiteSpace: 'nowrap' }}>
                            {excludeLabel}
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
}

export default DualListOptionRow;
